import { ContactContextBehaviour } from "./contactContextBehaviour";

export class ContactContextMyExpBehaviour extends ContactContextBehaviour {
  isContactModeFieldVisible(): boolean {
    return false;
  }
  isLicenseFieldVisible(): boolean {
    return false;
  }
  isLocationTypeFieldVisible(): boolean {
    return false;
  }
  getCriteriaComponentForConsole(): React.ReactNode {
    return null;
  }
  isCriteriaFieldVisible(): boolean {
    return false;
  }
  isDescriptionFieldVisible(): boolean {
    return false;
  }
  showAccessCriteriaAsReadOnly(): boolean {
    return true;
  }
  showCancelButton(): boolean {
    return false;
  }
}
